import Seo from "@/components/Seo";
import Hero from "@/components/home/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/home/Services";
import Urgence from "@/components/home/Urgence";
import Pourquoi from "@/components/home/Pourquoi";
import Gallery from "@/components/home/Gallery";
import Avis from "@/components/home/Avis";
import Zones from "@/components/home/Zones";
import Faq from "@/components/home/Faq";
import Showroom from "@/components/home/Showroom";
import DevisSection from "@/components/home/DevisSection";

export default function HomePage() {
  return (
    <>
      <Seo
        title="MSC Toitures — Couvreur à Champigny-sur-Marne (94) | Toiture & Zinguerie"
        description="MSC Toitures, votre couvreur à Champigny-sur-Marne et dans le Val-de-Marne (94). Réparation, rénovation, fuite de toiture, zinguerie et entretien. Déplacement et devis gratuits."
        path="/"
      />
      <Hero />
      <Marquee />
      <Services />
      <Urgence />
      <Pourquoi />
      <Gallery />
      <Avis />
      <Zones />
      <Faq />
      <Showroom />
      <DevisSection />
    </>
  );
}
